// extracted by mini-css-extract-plugin
export default {"page":"AboutPage_page__ycpE-","header":"AboutPage_header__pN5RC","part":"AboutPage_part__FmQ33"};